/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming



export class BaseApiLoginResponse {
    identifier : string;
    username : string;
    role : string;
    token : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.username = "" ;
                this.role = "" ;
                this.token = "" ;
        }
}

export class BaseCredential {
    username : string;
    password : string;

    constructor() 
    {
    	            this.username = "" ;
                this.password = "" ;
        }
}

export class LanguageCredential extends BaseCredential {
    preferredCulture : string;

    constructor() 
    {
    	        super();
		            this.preferredCulture = "" ;
        }
}

export class LoginData extends BaseCredential {
    role : string;
    resetPassword : string;
    confirmationCode : string;
    confirmedOn : string ;

    constructor() 
    {
    	        super();
		            this.role = "" ;
                this.resetPassword = "" ;
                this.confirmationCode = "" ;
                this.confirmedOn = null;
        }
}

export class UpdateCredentialVm extends LanguageCredential {
    identifier : string;

    constructor() 
    {
    	        super();
		            this.identifier = "" ;
        }
}

export class LoggedUserVM {
    completeName : string;
    preferredCulture : string;
    identifier : string;
    username : string;
    role : string;
    token : string;
    anagraficaData : AnagraficaData;

    constructor() 
    {
    	            this.completeName = "" ;
                this.preferredCulture = "" ;
                this.identifier = "" ;
                this.username = "" ;
                this.role = "" ;
                this.token = "" ;
                this.anagraficaData = new AnagraficaData();
        }
}

export class AnagraficaData {
    nome : string;
    cognome : string;

    constructor() 
    {
    	            this.nome = "" ;
                this.cognome = "" ;
        }
}

export class BaseEntity {
    createdOn : string ;
    modifiedOn : string ;
    disabledOn : string ;
    identifier : string;

    constructor() 
    {
    	            this.createdOn = null;
                this.modifiedOn = null;
                this.disabledOn = null;
                this.identifier = "" ;
        }
}

export class FondoTavola extends BaseEntity {
    nome : string;
    url : string;

    constructor() 
    {
    	        super();
		            this.nome = "" ;
                this.url = "" ;
        }
}

export class LocalizedValue {
    values : { [key: string]: string; };

    constructor() 
    {
    	            this.values = {};
        }
}

export class LocalizedEntity extends LocalizedValue {
    key : string;
    identifier : string;

    constructor() 
    {
    	        super();
		            this.key = "" ;
                this.identifier = "" ;
        }
}

export class KeyValuePairOfStringAndString {
    key : string;
    value : string;

    constructor() 
    {
    	            this.key = "" ;
                this.value = "" ;
        }
}

export class Product extends BaseEntity {
    wooCommerceId : number;
    nome : LocalizedEntity;
    wcImageUrl : string;
    categoria : string[];
    galleryImages : string[];
    collezione : string;
    sku : string;
    isSet : boolean;
    available : boolean;
    materiale : LocalizedEntity;
    dimensioni : LocalizedEntity;
    avvertenze : LocalizedEntity;
    diametro : LocalizedEntity;
    capienza : LocalizedEntity;
    price : number;
    regularPrice : number;
    salePrice : number;

    constructor() 
    {
    	        super();
		            this.wooCommerceId = null ;
                this.nome = new LocalizedEntity();
                this.wcImageUrl = "" ;
                this.categoria = [];
                this.galleryImages = [];
                this.collezione = "" ;
                this.sku = "" ;
                this.isSet = false ;
                this.available = false ;
                this.materiale = new LocalizedEntity();
                this.dimensioni = new LocalizedEntity();
                this.avvertenze = new LocalizedEntity();
                this.diametro = new LocalizedEntity();
                this.capienza = new LocalizedEntity();
                this.price = null ;
                this.regularPrice = null ;
                this.salePrice = null ;
        }
}

export class CategoryWithProductsVm {
    category : string;
    products : ProductUrl[];

    constructor() 
    {
    	            this.category = "" ;
                this.products = [];
        }
}

export class ProductUrl {
    wooCommerceId : number;
    sku : string;
    nome : string;
    category : string;
    isSet : boolean;
    collezione : string;
    prezzo : number;
    available : boolean;
    localizedName : LocalizedEntity;
    url : string;
    wcImageUrl : string;
    zIndex : number;

    constructor() 
    {
    	            this.wooCommerceId = null ;
                this.sku = "" ;
                this.nome = "" ;
                this.category = "" ;
                this.isSet = false ;
                this.collezione = "" ;
                this.prezzo = null ;
                this.available = false ;
                this.localizedName = new LocalizedEntity();
                this.url = "" ;
                this.wcImageUrl = "" ;
                this.zIndex = null ;
        }
}

export class GetProductsRequest {
    category : string;
    exclude : string[];

    constructor() 
    {
    	            this.category = "" ;
                this.exclude = [];
        }
}

export class Tavola extends BaseEntity {
    nome : string;
    fondoTavola : FondoTavola;
    customerId : number;
    cartHash : string;
    setsPiatti : ProductUrl[];
    setsDecorazioni : ProductUrl[];
    extraProducts : ProductUrl[];
    posto1 : PostoTavola;
    posto2 : PostoTavola;
    posto3 : PostoTavola;
    posto4 : PostoTavola;
    posto5 : PostoTavola;
    posto6 : PostoTavola;
    posto7 : PostoTavola;
    posto8 : PostoTavola;
    posto9 : PostoTavola;
    isPreset : boolean;

    constructor() 
    {
    	        super();
		            this.nome = "" ;
                this.fondoTavola = new FondoTavola();
                this.customerId = null ;
                this.cartHash = "" ;
                this.setsPiatti = [];
                this.setsDecorazioni = [];
                this.extraProducts = [];
                this.posto1 = new PostoTavola();
                this.posto2 = new PostoTavola();
                this.posto3 = new PostoTavola();
                this.posto4 = new PostoTavola();
                this.posto5 = new PostoTavola();
                this.posto6 = new PostoTavola();
                this.posto7 = new PostoTavola();
                this.posto8 = new PostoTavola();
                this.posto9 = new PostoTavola();
                this.isPreset = false ;
        }
}

export class PostoTavola {
    tovaglietta : ProductUrl;
    products : ProductUrl[];
    id : number;

    constructor() 
    {
    	            this.tovaglietta = new ProductUrl();
                this.products = [];
                this.id = null ;
        }
}

export class StepConfig extends BaseEntity {
    stepNumber : number;
    categories : CategoryAndOrder[];

    constructor() 
    {
    	        super();
		            this.stepNumber = null ;
                this.categories = [];
        }
}

export class CategoryAndOrder {
    category : string;
    order : number;

    constructor() 
    {
    	            this.category = "" ;
                this.order = null ;
        }
}

export class CreatePdfRequestVm {
    email : string;
    tavolaHtml : string;
    tavola : Tavola;
    language : string;

    constructor() 
    {
    	            this.email = "" ;
                this.tavolaHtml = "" ;
                this.tavola = new Tavola();
                this.language = "" ;
        }
}

export class Tovaglietta extends BaseEntity {
    nome : string;
    url : string;

    constructor() 
    {
    	        super();
		            this.nome = "" ;
                this.url = "" ;
        }
}

export class BaseUserForListVm {
    identifier : string;
    createdOn : string ;
    anagraficaData : AnagraficaData;
    loginData : LoginData;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.anagraficaData = new AnagraficaData();
                this.loginData = new LoginData();
        }
}

export class CloudAttachmentReference {
    attachmentIdentifier : string;
    publicUrl : string;

    constructor() 
    {
    	            this.attachmentIdentifier = "" ;
                this.publicUrl = "" ;
        }
}

export abstract class IHeaderDictionary {
    item : any[];
    /** Strongly typed access to the Content-Length header. Implementations must keep this in sync with the string representation. */
    contentLength : number;

    constructor() 
    {
    	            this.item = [];
                this.contentLength = null ;
        }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}